module.exports = __webpack_public_path__ + "img/schools.98448c99.png";